import * as React from 'react';
import { css } from '@emotion/css';
import { AppstoreOutlined, MenuOutlined } from '@ant-design/icons';

const viewSwitcherStyles = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
  .icon-styles {
    padding: 5px;
    &: hover {
      cursor: pointer;
      color: #40a9ff;
    }
  }
`;

export interface ILayoutSwitchProps {
  switchViewLayout: any;
}

export default function LayoutSwitch({ switchViewLayout }: ILayoutSwitchProps) {
  return (
    <div className={viewSwitcherStyles}>
      <AppstoreOutlined
        className="icon-styles"
        onClick={() => switchViewLayout('grid')}
      />
      <MenuOutlined
        className="icon-styles"
        onClick={() => switchViewLayout('list')}
      />
    </div>
  );
}
